
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.373 4.73L7.945 7.454l-3.194.438c-.572.079-.802.743-.387 1.124l2.311 2.12-.546 2.993c-.099.541.507.947 1.014.693l2.858-1.413 2.857 1.413c.507.251 1.113-.152 1.014-.693l-.546-2.994 2.31-2.12c.416-.38.186-1.044-.386-1.123l-3.194-.438-1.428-2.724c-.256-.486-.997-.492-1.255 0z","fill":"#FFA826"}})])
          )
        }
      }
    